import { SystemStyleObject } from '@chakra-ui/react';
import {
  ColorMode,
  getTypographyToken,
} from '@allergan-data-labs/alle-elements-core';

export const getActionMenuGroupStyles = (
  colorMode: ColorMode
): SystemStyleObject => {
  return {
    color: `${colorMode}.Text/Neutral/Default`,
    ...getTypographyToken('Caption/Medium/Medium'),
    margin: '0',
    paddingTop: '4',
    paddingBottom: '4',
    paddingLeft: '8',
    paddingRight: '8',
    display: 'flex',
    alignItems: 'center',
    height: '32px',
  };
};
